export default {
    name: 'recommendationRegistries',
    serverName: '/api/v1/recomendation_register/register/',
    apiUrl: '/api/v1/recomendation_register/register/',
    // userUrl: '/api/v1/teleagronom_user/owners/',
    // fieldUrl: '/api/v1/mordovia/field_info/',
    // fileUploadUrl: '/api/v1/mycological_calculator/imap_picture/'
};
